import { Box, Tabs, Tab, TabList, Heading } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React, { useMemo, useState } from 'react';

import { PortfolioStatementsExpensesFeesContainer } from './PortfolioStatementsExpensesFeesContainer';
import { PortfolioStatementsOutstandingLedgerContainer } from './PortfolioStatementsOutstandingLedgerContainer';
import { colors } from 'packages/common-frontend/colors';
import { MonthlySummaryViewContainer } from 'packages/statements/ui/MonthlySummaryViewContainer';

export enum StatementsTabOptionKeys {
  outstandingLedger = 'outstandingLedger',
  expensesFees = 'expensesFees',
  monthlySummary = 'monthlySummary',
}
type StatementsTabConfig = {
  key: StatementsTabOptionKeys;
  label: string;
};
const statementsTabOptions: Record<
  StatementsTabOptionKeys,
  StatementsTabConfig
> = {
  outstandingLedger: {
    key: StatementsTabOptionKeys.outstandingLedger,
    label: 'Outstanding Ledger',
  },
  expensesFees: {
    key: StatementsTabOptionKeys.expensesFees,
    label: 'Facility Expenses & Fees',
  },
  monthlySummary: {
    key: StatementsTabOptionKeys.monthlySummary,
    label: 'Monthly Summary',
  },
};

export const PortfolioStatementsContainer: React.FC<{
  creditFacilityId: string;
}> = withLDConsumer()(({ creditFacilityId, flags }) => {
  const [activeTab, setActiveTab] = useState<StatementsTabOptionKeys>(
    StatementsTabOptionKeys.outstandingLedger,
  );

  const tabs = useMemo<StatementsTabConfig[]>(() => {
    const tabsToShow = [
      statementsTabOptions.outstandingLedger,
      statementsTabOptions.expensesFees,
    ];
    if (flags?.isStatementsMonthlySummaryEnabled) {
      tabsToShow.push(statementsTabOptions.monthlySummary);
    }
    return tabsToShow;
  }, [flags]);

  return (
    <>
      <Heading as="h3" fontSize="24px" mb="24px">
        Statements
      </Heading>
      <Box backgroundColor={colors.millet[50]} padding="24px">
        <Tabs
          variant="line"
          index={tabs.findIndex(({ key }) => key === activeTab)}
          colorScheme="blue"
        >
          <TabList>
            {tabs.map(({ label, key }) => (
              <Tab
                key={key}
                onClick={() => {
                  setActiveTab(key);
                }}
                fontSize="sm"
                mt="0"
              >
                {label}
              </Tab>
            ))}
          </TabList>
        </Tabs>
        <Box
          mt="32px"
          backgroundColor="white"
          borderRadius="8px"
          padding="24px"
        >
          <Heading as="h3" fontSize="24px" mb="24px">
            {statementsTabOptions[activeTab].label}
          </Heading>
          {activeTab === StatementsTabOptionKeys.outstandingLedger && (
            <PortfolioStatementsOutstandingLedgerContainer
              creditFacilityId={creditFacilityId}
            />
          )}
          {activeTab === StatementsTabOptionKeys.expensesFees && (
            <PortfolioStatementsExpensesFeesContainer
              creditFacilityId={creditFacilityId}
            />
          )}
          {activeTab === StatementsTabOptionKeys.monthlySummary && (
            <MonthlySummaryViewContainer creditFacilityId={creditFacilityId} />
          )}
        </Box>
      </Box>
    </>
  );
});
